import React from 'react';
import styles from './EmailForm.module.css';

export default class EmailForm extends React.Component {

    constructor(props) {
        super(props);

        var initialState = {
            email_address: ''
        };

        this.state = initialState;

        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: (event.target.type === 'checkbox') ? event.target.checked: event.target.value
        })
    }

    onSubmit(event) {
        event.preventDefault();

        if (this.props.onSend) {
            this.props.onSend(this.state.email_address);
        }
    }

    render() {
        return (
            <form onSubmit={this.onSubmit}>
                <div className="col-lg-9">
                    <div className="form-group">
                        <label htmlFor="sendEmailInput">Email Results to:</label>
                        <input type="email" className="form-control" id="sendEmailInput" name="email_address" value={this.state.email_address} onChange={this.handleChange} />
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="hidden visible-lg-block" styleName="styles.padding-label" />
                    <button type="submit" className="btn btn-dl-green">SEND</button>
                </div>
            </form>
        )
    }
}